module.exports = `${require.publicPath}404.65626161.png`;